var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_413_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0989 17.4701L68.5749 25.9941C67.9511 26.6178 67.1611 26.9089 66.3711 26.9089C65.581 26.9089 64.791 26.6178 64.1673 25.9941C62.9615 24.7883 62.9615 22.7924 64.1673 21.5865L72.6914 13.0625C65.3731 6.8254 55.9343 2.99997 45.5807 2.99997C22.6282 2.99997 4 21.6281 4 44.5807C4 67.5332 22.6282 86.1614 45.5807 86.1614C68.5333 86.1614 87.1614 67.5332 87.1614 44.5807C87.1614 34.2271 83.336 24.7883 77.0989 17.4701Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "loan-path-rupee",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 27.8542C33 27.0972 33.3292 26.3712 33.9153 25.836C34.5013 25.3007 35.2962 25 36.125 25H54.875C55.7038 25 56.4987 25.3007 57.0847 25.836C57.6708 26.3712 58 27.0972 58 27.8542C58 28.6112 57.6708 29.3371 57.0847 29.8724C56.4987 30.4076 55.7038 30.7084 54.875 30.7084H50.0781C50.6442 31.6023 51.0742 32.5625 51.3562 33.5625H54.875C55.7038 33.5625 56.4987 33.8632 57.0847 34.3985C57.6708 34.9338 58 35.6597 58 36.4167C58 37.1737 57.6708 37.8997 57.0847 38.4349C56.4987 38.9702 55.7038 39.2709 54.875 39.2709H51.3562C50.7707 41.3351 49.5648 43.2087 47.8747 44.6799C46.1846 46.1511 44.0778 47.1614 41.7922 47.5965L51.225 60.5217C51.4611 60.8333 51.627 61.1848 51.7128 61.5556C51.7986 61.9265 51.8027 62.3092 51.7248 62.6815C51.6469 63.0538 51.4886 63.4081 51.2592 63.724C51.0297 64.0398 50.7337 64.3107 50.3884 64.5209C50.0431 64.7311 49.6554 64.8763 49.2479 64.9482C48.8405 65.0201 48.4214 65.0171 48.0152 64.9395C47.6091 64.8619 47.2239 64.7111 46.8822 64.4961C46.5405 64.281 46.2491 64.006 46.025 63.6869L33.525 46.5619C33.2114 46.1321 33.0314 45.6326 33.0042 45.1167C32.977 44.6008 33.1035 44.0878 33.3704 43.6324C33.6372 43.177 34.0344 42.7963 34.5195 42.5309C35.0046 42.2654 35.5595 42.1252 36.125 42.1251H39.25C41.5625 42.1251 43.5828 40.9777 44.6641 39.2709H36.125C35.2962 39.2709 34.5013 38.9702 33.9153 38.4349C33.3292 37.8997 33 37.1737 33 36.4167C33 35.6597 33.3292 34.9338 33.9153 34.3985C34.5013 33.8632 35.2962 33.5625 36.125 33.5625H44.6641C44.1156 32.6944 43.3265 31.9735 42.376 31.4724C41.4256 30.9714 40.3474 30.7078 39.25 30.7084H36.125C35.2962 30.7084 34.5013 30.4076 33.9153 29.8724C33.3292 29.3371 33 28.6112 33 27.8542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1199 2.04331C89.7873 1.29486 89.2051 0.671149 88.4151 0.338503C88.0409 0.213761 87.6667 0.1306 87.2508 0.1306H70.6186C68.9137 0.1306 67.5 1.54434 67.5 3.24915C67.5 4.95396 68.9137 6.36771 70.6186 6.36771H79.7247L72.7808 13.3117C74.3608 14.6839 75.8161 16.1392 77.1883 17.7192L84.1323 10.7753V19.8814C84.1323 21.5863 85.546 23 87.2508 23C88.9557 23 90.3694 21.5863 90.3694 19.8814V3.24915C90.3694 2.83335 90.2862 2.45912 90.1199 2.04331Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_413_7",
    x: 0,
    y: 0.1306,
    width: 94.3694,
    height: 94.0308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_413_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_413_7",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan);
export default __webpack_public_path__ + "static/media/loan.2292f20c8694aa83b4f9cda4ca3f50ca.svg";
export { ForwardRef as ReactComponent };